import { segment } from '../SegmentAnalyticsUtils';

export const sendSegmentProfileIdentifyEvent = (userProfileData: any) => {
  const {
    name,
    lastName,
    gender,
    phoneNumber,
    profilePicUrl,
    userId,
    iWantToReceiveUpdatesDirectlyOnWhatsapp,
  } = userProfileData;

  segment.identify(userId, {
    firstName: name ?? '',
    lastName: lastName ?? '',
    gender: gender ? gender.toLowerCase() : '',
    avatar: profilePicUrl ?? '',
    phone: phoneNumber,
    email: userProfileData.email ?? '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    we_whatsapp_opt_in: iWantToReceiveUpdatesDirectlyOnWhatsapp ?? undefined,
  });
};

export const sendSegmentUpdateProfileIdentifyEvent = (
  userProfileData: any,
  requestObject: any,
) => {
  let gender = requestObject.gender ?? userProfileData.gender;
  gender = gender ? gender.toLowerCase() : '';
  segment.identify(userProfileData.userId, {
    firstName: requestObject.name ?? userProfileData.name ?? '',
    lastName: requestObject.last_name ?? userProfileData.lastName ?? '',
    gender: gender,
    avatar:
      requestObject.profile_pic_url ?? userProfileData.profilePicUrl ?? '',
    phone: userProfileData.phoneNumber,
    email: requestObject.email ?? userProfileData.email ?? '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    we_whatsapp_opt_in:
      requestObject.whatsappInfoStatus ??
      requestObject.receiveUpdatesInfoStatus ??
      undefined,
  });
};

export const sendSegmentUpdatePhoneNumberIdentifyEvent = (
  userProfileData: any,
): void => {
  segment.identify(userProfileData.userId, {
    phone: userProfileData.phoneNumber,
  });
};

export const sendSegmentUpdateEmailIdentifyEvent = (
  userProfileData: any,
): void => {
  segment.identify(userProfileData.userId, {
    email: userProfileData.email,
  });
};
